<div style="position: fixed; top:0; z-index: 1000; left:0; height:100%; width:100%; background: #222c;">
</div>

<div class="sideBar-info">
  <ion-icon color='danger' name="close-circle" style="position: fixed; right:5%; top:6%; z-index: 99;"
    class='font2 floatingCloseAttachment cursorpoint' (click)='closePopup.emit()'></ion-icon>
  <div class="bold font1_5 margin10px">{{heading}}</div>
  <div class="margin10px">{{description}}</div>
  <div (click)="clickApprover(emp)" *ngFor="let emp of empList">
    <app-user-list-card [emp]="emp" [showImage]="false"></app-user-list-card>
  </div>
</div>